import React from "react";
import PageCard from "features/shared/components/card/PageCard";
import InfoItem from "features/shared/components/infoItem/InfoItem";
import { useQuery } from "data/hooks/useQuery";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import { Version_Info } from "data/endpoints";
import VersionInfoDTO from "../dtos/VersionInfoDTO";

const VersionSection = () => {
  // translation
  const t = useTranslationWithPrefix("admin\\administration", "versionSection");

  // fetch-data
  const { data: versionInfo } = useQuery<VersionInfoDTO>(
    { url: Version_Info },
    {}
  );

  // render
  return (
    <PageCard title={t("versionInfo")} bodyClassName="pb-0">
      <div className="row no-gutters">
        <div className="col-12 col-sm-6 col-md-4 pb-2">
          <InfoItem
            title={t("appVersion")}
            value={process.env.REACT_APP_VERSION ?? t("unknown")}
            icon="tablet-alt"
          />
        </div>
        <div className="col-12 col-sm-6 col-md-4 pb-2">
          <InfoItem
            title={t("apiVersion")}
            value={versionInfo?.apiVersion ?? t("unknown")}
            icon="server"
          />
        </div>
        <div className="col-12 col-sm-6 col-md-4 pb-2">
          <InfoItem
            title={t("dbVersion")}
            value={versionInfo?.dbVersion ?? t("unknown")}
            icon="database"
          />
        </div>
      </div>
    </PageCard>
  );
};

export default VersionSection;
